import React from 'react'
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import * as S from './styles'
import { IconButton } from '@mui/material';
import { SpinnerLoading } from '@/main/components/shared/styles';
import RenderTooltipMessage from '@/main/components/shared/renderTooltipMessage/renderTooltipMessage';
import { getTranslateByKey } from '@/main/services/utils';

interface IAreaButtonsEditPartProps {
  isLoadingSaveEdit: boolean;
  onClickConfirm: () => void
  onClickCancel: () => void
}

function AreaButtonsEditPart({
  isLoadingSaveEdit,
  onClickCancel,
  onClickConfirm
}: IAreaButtonsEditPartProps) {

  function handleClickConfirm(e: React.MouseEvent<HTMLElement>) {
    e.stopPropagation()
    e.preventDefault()
    onClickConfirm()
  };

  function handleClickCancel(e: React.MouseEvent<HTMLElement>) {
    e.stopPropagation()
    e.preventDefault()
    onClickCancel()
  }

  if (isLoadingSaveEdit) return (
    <S.Container>
      <SpinnerLoading />
    </S.Container>
  )

  return (
    <S.Container>
      <RenderTooltipMessage tooltipMessage={getTranslateByKey('information.save')}>
        <IconButton
          id='id-createanswer-button-confirm-edit'
          onClick={handleClickConfirm}
          disabled={isLoadingSaveEdit}
        >
          <CheckIcon />
        </IconButton>
      </RenderTooltipMessage>
      <RenderTooltipMessage tooltipMessage={getTranslateByKey('information.cancel')}>
        <IconButton
          id='id-createanswer-button-cancel-edit'
          onClick={handleClickCancel}
          disabled={isLoadingSaveEdit}
        >
          <CloseIcon />
        </IconButton>
      </RenderTooltipMessage>
    </S.Container>
  )
}

export default AreaButtonsEditPart